import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { showNutritionValue } from 'organisms/NutritionAllergenLandingPage/AU/NutritionAllergenUtilities/NutritionAllergenUtils';
import { NUTRITION_ALLERGEN_CONSTANTS } from 'organisms/NutritionAllergen/Constants/NutritionAllergenConstant';
import { AVERAGE_SERVING_SIZE } from 'organisms/NutritionAllergenLandingPage/AU/NutritionAllergenConstants/NutritionAllergenConstants';
const NutritionContainer = props => {
  const { nutritionalDetails, onClickServehandler, onClickGramHandler, showPerGram, showPerServe } = props;
  return (
    <React.Fragment>
      <div className='nutrition-header-global'>
        <div className='nutrition-name-global'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.NUTRITION)}</div>
        <div className='nutrition-value'>
          <div className='nutrition-value-serve'>
            <button
              data-testid='per_serve_handler'
              type='button'
              className={'per-serve' + (showPerServe && !showPerGram ? ' activeServe' : '')}
              onClick={onClickServehandler}
            >
              {translateWithI18Next(TRANSLATE_MAPPING_KEY.PER_SERVE)}
            </button>
          </div>
          <div className='nutrition-value-gram'>
            <button
              data-testid='per_gram_handler'
              type='button'
              className={'per-gram' + (showPerGram && !showPerServe ? ' activeGram' : '')}
              onClick={onClickGramHandler}
            >
              {translateWithI18Next(TRANSLATE_MAPPING_KEY.PER_GRAM)}
            </button>
          </div>
          <div></div>
        </div>
      </div>
      <div className='nutrition-details-global'>
        {nutritionalDetails?.map(item => {
          return (
            <>
              {((item.nutritionComponent !== AVERAGE_SERVING_SIZE && showPerGram) || showPerServe) && (
                <div className='nutrition-name-amoumt-details'>
                  {showPerGram && (
                    <div className='nutrition-amount-global'>{showNutritionValue(item, item?.gramWiseValue)}</div>
                  )}
                  {showPerServe && (
                    <div className='nutrition-amount-global'>{showNutritionValue(item, item?.serveWiseValue)}</div>
                  )}
                  <div className='nutrition-name-unit-global'>
                    <div className='nutrition-name-global'>{item?.nutritionComponent}</div>
                    <div className='nutrition-unit-global'>
                      (
                      {item?.nutritionUnit === NUTRITION_ALLERGEN_CONSTANTS.KJ_TEXT
                        ? translateWithI18Next(TRANSLATE_MAPPING_KEY.KJ)
                        : item?.nutritionUnit}
                      )
                    </div>
                  </div>
                </div>
              )}
            </>
          );
        })}
      </div>
    </React.Fragment>
  );
};
export default NutritionContainer;
